import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 图表库
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import Navigation from "./components/Navigation.vue"
import footer from "@/components/footer.vue"
import store from './store'

import "@/mockjs/index";
import axios from 'axios'
// import slidenIn from '@/Js/slidenIn.js';

// 定义特性标志
window.__VUE_PROD_DEVTOOLS__ = false;
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;


const app = createApp(App).use(store);

// axios.defaults.headers.common['User-Agent'] = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/126.0.0.0 Safari/537.36 Edg/126.0.0.0'
app.config.globalProperties.$axios = axios;

// 全局组件
app.component('Navigation', Navigation);
app.component('Footer', footer);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// app.directive("slide_in", {slidenIn});
const animationMap = new WeakMap();
const ob = new IntersectionObserver((entries) => {
    for (const entry of entries) {
        if (entry.isIntersecting) {
            const animation = animationMap.get(entry.target);
            animation.play();
            ob.unobserve(entry.target);
        }
    }
})

app.directive("sliden_in", {
    mounted(el) {
        const DISTANCE = 150;
        const DURATION = 1000;

        const animation = el.animate([
            {
                transform: 'translateY(150px)',
                opacity: 0,
            },
            {
                transform: 'translateY(0)',
                opacity: 1,
            },
        ],
            {
                duration: DURATION,
                easing: 'ease-in-out',
            });

        animation.pause();
        animationMap.set(el, animation);
        ob.observe(el);
    },

    unmounted(el) {
        ob.unobserve(el);
    }
})

app.use(router).use(ElementPlus).mount('#app')
